(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["charmme-shipping-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('charmme-shipping')) return;
  const KEY = 'charmme.shipping.cep.v1';
  const TTL = 7 * 24 * 60 * 60 * 1000;
  const instances = new Set();
  let sequence = 0;
  const digits = value => String(value || '').replace(/\D/g, '');
  const format = value => value.length > 5 ? `${value.slice(0, 5)}-${value.slice(5)}` : value;
  const valid = value => /^\d{8}$/.test(value);
  const parse = raw => {
    try {
      const value = JSON.parse(raw);
      if (value?.version === 1 && typeof value.cep === 'string' && valid(value.cep) &&
          Number.isFinite(value.confirmedAt) && value.confirmedAt <= Date.now() &&
          Date.now() - value.confirmedAt < TTL) return value;
    } catch (_) {}
    return null;
  };
  let state = null;
  let memoryOnly = false;
  const read = () => {
    if (memoryOnly) return state;
    try {
      const raw = localStorage.getItem(KEY);
      const saved = parse(raw);
      if (raw && !saved) localStorage.removeItem(KEY);
      return saved;
    } catch (_) { memoryOnly = true; return state; }
  };
  state = read();
  const current = () => {
    if (state && Date.now() - state.confirmedAt >= TTL) {
      state = null;
      try { localStorage.removeItem(KEY); } catch (_) {}
    }
    return state;
  };
  const sync = () => instances.forEach(instance => instance.paint());
  const commit = value => {
    state = value;
    try {
      if (state) localStorage.setItem(KEY, JSON.stringify(state));
      else localStorage.removeItem(KEY);
    } catch (_) { memoryOnly = true; }
    sync();
  };
  class CharmmeShipping extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        this.input = this.querySelector('[data-input]');
        this.error = this.querySelector('[data-error]');
        this.button = this.querySelector('[data-calculate]');
        this.result = this.querySelector('[data-result]');
        if (!this.input || !this.error || !this.button || !this.result) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.error.id = `charmme-shipping-error-${++sequence}`;
        this.input.setAttribute('aria-describedby', this.error.id);
        this.dirty = false;
        this.loading = false;
        this.addEventListener('input', event => {
          if (event.target !== this.input) return;
          this.cancelCalculation();
          this.input.value = format(digits(this.input.value).slice(0, 8));
          this.dirty = true;
          this.setError(false);
          this.paint();
        }, options);
        this.addEventListener('click', event => {
          if (event.target.closest('[data-calculate]')) this.calculate();
        }, options);
        this.addEventListener('keydown', event => {
          if (event.target !== this.input || event.key !== 'Enter') return;
          event.preventDefault();
          event.stopPropagation();
          this.calculate();
        }, options);
        instances.add(this);
        this.querySelector('[data-controls]').hidden = false;
        this.paint();
      });
    }
    disconnectedCallback() {
      this.cancelCalculation();
      this.controller?.abort();
      this.controller = null;
      instances.delete(this);
    }
    cancelCalculation() {
      clearTimeout(this.timer);
      this.timer = null;
      this.loading = false;
    }
    setError(show) {
      this.error.hidden = !show;
      this.input.setAttribute('aria-invalid', String(show));
    }
    calculate() {
      if (this.loading) return;
      const cep = digits(this.input.value);
      if (!valid(cep)) {
        this.dirty = true;
        this.setError(true);
        this.paint();
        this.input.focus();
        return;
      }
      this.setError(false);
      this.loading = true;
      this.dirty = true;
      this.paint();
      this.timer = setTimeout(() => {
        this.timer = null;
        if (!this.isConnected || digits(this.input.value) !== cep) return;
        this.loading = this.dirty = false;
        commit({ version: 1, cep, confirmedAt: Date.now() });
      }, 800);
    }
    paint() {
      const saved = current();
      this.result.hidden = !saved || this.dirty || this.loading;
      this.button.disabled = this.loading;
      this.button.classList.toggle('is-loading', this.loading);
      this.button.setAttribute('aria-busy', String(this.loading));
      this.querySelector('[data-loading-status]').hidden = !this.loading;
      if (!this.dirty) this.input.value = saved ? format(saved.cep) : '';
    }
  }
  customElements.define('charmme-shipping', CharmmeShipping);
  window.addEventListener('storage', event => {
    if (event.key !== KEY && event.key !== null) return;
    try { if (event.storageArea && event.storageArea !== localStorage) return; } catch (_) {}
    state = parse(event.newValue);
    sync();
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) state = read();
    sync();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') sync();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
